import { render, staticRenderFns } from "./BookingStatus.vue?vue&type=template&id=5a07d790&scoped=true&"
import script from "./BookingStatus.vue?vue&type=script&lang=js&"
export * from "./BookingStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a07d790",
  null
  
)

export default component.exports